import { useState } from 'react';

export interface CommentsTabMeta {
  tabId: string;
  panelId: string;
}

const useCommentsPanel = () => {
  const [selectedTabMeta, setSelectedTabMeta] = useState<CommentsTabMeta | null>(null);

  return { selectedTabMeta, setSelectedTabMeta };
};

export default useCommentsPanel;
